<template>
  <v-dialog
    :model-value="modelValue"
    max-width="520"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-card>
      <v-card-title class="d-flex align-center">
        <span>Commenter contact</span>
        <v-spacer></v-spacer>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click="$emit('update:modelValue', false)"
        />
      </v-card-title>
      <v-card-text>
        <v-progress-linear
          v-if="loading"
          indeterminate
          color="primary"
          class="mb-4"
        />

        <v-alert
          v-if="error"
          type="error"
          variant="tonal"
          class="mb-4"
        >
          {{ error }}
        </v-alert>

        <div
          v-if="contact && !loading"
          class="d-flex flex-column comment-author-contact-dialog__details"
        >
          <div>
            <div class="text-caption text-medium-emphasis">Name</div>
            <div class="font-weight-medium">
              {{ contactName }}
            </div>
          </div>
          <div>
            <div class="text-caption text-medium-emphasis">Email</div>
            <div class="font-weight-medium">
              {{ contactEmail || "No email found" }}
            </div>
          </div>
          <div v-if="contact.hospital">
            <div class="text-caption text-medium-emphasis">Hospital</div>
            <div>{{ contact.hospital }}</div>
          </div>
          <div v-if="contact.trainingYear">
            <div class="text-caption text-medium-emphasis">Training year</div>
            <div>{{ contact.trainingYear }}</div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" @click="$emit('update:modelValue', false)">
          Close
        </v-btn>
        <v-btn
          v-if="contactEmail"
          color="primary"
          prepend-icon="mdi-email"
          :href="contactMailto"
        >
          Email commenter
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  contact: {
    type: Object,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  error: {
    type: String,
    default: "",
  },
});

defineEmits(["update:modelValue"]);

const contactName = computed(() => {
  const contact = props.contact || {};
  const profileName = [contact.firstName, contact.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();
  return (
    contact.name ||
    profileName ||
    contact.commentAuthorName ||
    contact.email ||
    "Commenter"
  );
});

const contactEmail = computed(() => String(props.contact?.email || "").trim());

const contactMailto = computed(() =>
  contactEmail.value ? `mailto:${contactEmail.value}` : "",
);
</script>

<style scoped>
.comment-author-contact-dialog__details {
  gap: 12px;
}
</style>
